'use client';
const defaultResponseTransform = (response)=>response.json();

export { defaultResponseTransform };
//# sourceMappingURL=defaultResponseTransform.js.map
